import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-typeahead/css/Typeahead.min.css";
import "react-bootstrap-typeahead/css/Typeahead-bs4.min.css";

import { PlaceProvider } from "./store/place/placeContext";
import { ResultsProvider } from "./store/results/resultsContext";
import { AuthProvider } from "./provider/AuthProvider"

ReactDOM.render(
  // <React.StrictMode>
  <AuthProvider>
    <PlaceProvider>
      <ResultsProvider>
        <App />
      </ResultsProvider>
    </PlaceProvider>
  </AuthProvider>,
  // </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
